import Vue from 'vue';
import Vuex from 'vuex';
import brcStore from '@/stores/brc-store';
import aocStore from '@/stores/aoc-store';
import messageStore from '@/stores/message-store';

Vue.use(Vuex);

const stores = new Vuex.Store({
    modules: {
        brc: brcStore,
        aoc: aocStore,
        message: messageStore
    }
});

export default stores;
